import { computed, ref, getCurrentInstance} from "@vue/composition-api";
import store from "@/store";
import axios from "@/libs/axios";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { encryptData } from "@/utils/encryptUserDataUtils";
import { debounce } from "lodash";
import { useTranslates } from "@/utils/useTranslates";

export function useDiskInfo(dvr) {
  const toast = useToast();
  const isDiskHeadersLoading = ref(false)
  const isDisksInfoLoading = ref(false)
  const showNoDataMessage = ref(false)
  const disksTabs= ref([])
  const disksInfo = ref([])
  const fields = ref([])
  const deviceInfo = ref(null)
  const diskStatus = ref(null)

  async function getDisksInfo() {
    try {
      const params = {
        idDvr: dvr.id,
      }
      isDiskHeadersLoading.value = true
      const {data} = await axios.get('/v1/hanwha/dvr/admin/get_disks_info', {params})
      disksTabs.value = data.data.Disks
      if (Array.isArray(data.data.Disks) && data.data.Disks.length === 0) showNoDataMessage.value = true
      isDiskHeadersLoading.value = false
      if(data.data.Disks.length) {
        getDiskInfo(data.data.Disks[0].Index)
      }
    } catch(error) {
      isDiskHeadersLoading.value = false
      showNoDataMessage.value = true
      toast({
        component: ToastificationContent,
        props: {
          title: error?.response?.data?.message ?? 'Error getting disks information',
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    }
  }
  async function getDiskInfo(diskIndex) {
    try {
      const params = {
        idDvr: dvr.id,
        diskIndex
      }
      isDisksInfoLoading.value = true
      const {data} = await axios.get('/v1/hanwha/dvr/admin/get_disk_info', {params})
      disksInfo.value[diskIndex] = data?.data?.data ?? null
      fields.value = data?.data?.headers ?? null
      deviceInfo.value = data?.data?.info ?? null
      diskStatus.value = data?.data?.status ?? null
      isDisksInfoLoading.value = false
    } catch(error) {
        isDisksInfoLoading.value = false
      toast({
        component: ToastificationContent,
        props: {
          title: error?.response?.data?.message ?? 'Error getting disk information',
          icon: "AlertTriangleIcon",
          variant: "danger",
        },
      });
    }
  }

  return {
    disksTabs,
    isDiskHeadersLoading,
    showNoDataMessage,
    disksInfo,
    isDisksInfoLoading,
    deviceInfo,
    diskStatus,
    fields,
    getDisksInfo,
    getDiskInfo
  }
}